module.exports = __webpack_public_path__ + "img/db_text.e90a810c.png";